import { Type, type Static } from '@sinclair/typebox';
import { PublicScopeSchema } from './scope.schema';

export const ScopesResponseSchema = Type.Object({
  object: Type.Literal('Scopes', { description: 'The type of the returned collection.' }),
  data: Type.Array(PublicScopeSchema, { description: 'The scopes in the current page.' }),
  has_more: Type.Boolean({ description: 'Whether more scopes are available after the current page.' }),
});

export type ScopesResponse = Static<typeof ScopesResponseSchema>;
